var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelTrainStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1764px",
    height: "1476px",
    viewBox: "0 0 1764 1476",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Travel Train Station") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created by Webpixels.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "travel-train-station"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFC933",
    fillRule: "nonzero",
    cx: 1105.1,
    cy: 90.7,
    r: 90.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2,1475.9 C4.1,1475.9 4.1,1472.9 2.2,1472.9 C0.3,1472.9 0.3,1475.9 2.2,1475.9 L2.2,1475.9 Z",
    id: "Path",
    fill: "#F1F2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(57.000000, 421.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.4,
    y1: 452,
    x2: 1704,
    y2: 452,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.9,0.2 L634.6,0.2 C629.4,0.2 625.2,4.4 625.2,9.6 L625.2,9.6 L1485.20175,9.6 L1485.20175,9.6 C1485.3,4.4 1481.1,0.2 1475.9,0.2 Z",
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.000000, 362.000000)",
    fillRule: "nonzero",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CED5E5",
    cx: 50.8,
    cy: 50.5,
    r: 50.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F7",
    cx: 50.8,
    cy: 50.5,
    r: 38.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CED5E5",
    cx: 201.6,
    cy: 50.5,
    r: 50.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F7",
    cx: 201.6,
    cy: 50.5,
    r: 38.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CED5E5",
    cx: 804.8,
    cy: 50.5,
    r: 50.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F7",
    cx: 804.8,
    cy: 50.5,
    r: 38.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CED5E5",
    cx: 955.6,
    cy: 50.5,
    r: 50.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F2F7",
    cx: 955.6,
    cy: 50.5,
    r: 38.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.000000, 9.000000)",
    fill: "#F1F2F7",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.3,0.6 C361.6,23 332.6,59.9 275.8,113.4 C173,210.3 27.2,218.4 27,218.4 C9.6,260.2 -5.68434189e-14,306.1 -5.68434189e-14,354.2 L-5.68434189e-14,354.2 C-5.68434189e-14,393.3 31.7,425.1 70.9,425.1 L1417.8,425.1 C1437.6,425.1 1453.6,409.1 1453.6,389.3 L1453.6,36.4 C1453.6,16.6 1437.6,0.6 1417.8,0.6 L376.3,0.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.3,0.6 L353.6,0.6 C206.4,0.6 80.3,90.5 27,218.4 C27.2,218.4 173,210.3 275.8,113.4 C332.6,59.8 361.6,22.9 376.3,0.6 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1275.6,195.2 L383.1,195.2 L451.4,115.9 C466.3,98.6 488.1,88.6 511,88.6 L1403.6,88.6 L1335.3,167.9 C1320.3,185.2 1298.5,195.2 1275.6,195.2 Z",
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,272.4 L129.4,272.4 C132.9,267 129,259.8 122.5,259.8 L84.3,259.8 C80.5,272.2 77.4,284.9 75,297.8 L82.7,297.8 C101.5,297.8 119.1,288.2 129.4,272.4 Z",
    id: "Path",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.3,9.6 L422.6,9.6 C275.4,9.6 149.3,99.5 96,227.4 C96.2,227.4 242,219.3 344.8,122.4 C401.6,68.8 430.6,31.9 445.3,9.6 Z",
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.7,
    y1: 249.4,
    x2: 1522.6,
    y2: 249.4,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.9,
    y1: 383.8,
    x2: 1522.6,
    y2: 383.8,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.7,
    y1: 88.6,
    x2: 537.8,
    y2: 195.2,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 784.4,
    y1: 88.6,
    x2: 692.6,
    y2: 195.2,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 939.2,
    y1: 88.6,
    x2: 847.4,
    y2: 195.2,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1094,
    y1: 88.6,
    x2: 1002.1,
    y2: 195.2,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1248.8,
    y1: 88.6,
    x2: 1156.9,
    y2: 195.2,
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.4,
    y1: 463.3,
    x2: 1704,
    y2: 463.3,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 1522.6,
    y: 58,
    width: 45.4,
    height: 325.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1530.5,
    y1: 58,
    x2: 1530.5,
    y2: 383.8,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1540,
    y1: 58,
    x2: 1540,
    y2: 383.8,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1549.4,
    y1: 58,
    x2: 1549.4,
    y2: 383.8,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1558.9,
    y1: 58,
    x2: 1558.9,
    y2: 383.8,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.5,434 L1603.8,434 C1584,434 1568,418 1568,398.2 L1568,45.4 C1568,25.6 1584,9.6 1603.8,9.6 L1678.5,9.6",
    id: "Path",
    stroke: "#F1F2F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero",
    points: "1522.6 313.1 228.9 313.1 253.2 289.3 1522.6 289.3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9,
    y1: 434,
    x2: 1470.4,
    y2: 434,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(315.000000, 918.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.000000, 461.000000)",
    fill: "#283444",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,26.3 L5.8,26.3 C2.7,26.3 0.1,23.7 0.1,20.6 L0.1,6.2 C0.1,3.1 2.7,0.5 5.8,0.5 L5.8,0.5 C8.9,0.5 11.5,3.1 11.5,6.2 L11.5,20.6 C11.5,23.7 8.9,26.3 5.8,26.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3,26.3 L145.3,26.3 C142.2,26.3 139.6,23.7 139.6,20.6 L139.6,6.2 C139.6,3.1 142.2,0.5 145.3,0.5 L145.3,0.5 C148.4,0.5 151,3.1 151,6.2 L151,20.6 C151,23.7 148.4,26.3 145.3,26.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.000000, 10.000000)",
    id: "Path",
    stroke: "#CED5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.9,
    y1: 0.4,
    x2: 0.9,
    y2: 103.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.3,
    y1: 0.4,
    x2: 94.3,
    y2: 103.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,468.4 L57.8,468.4 C26.2,468.4 0.6,442.8 0.6,411.2 L0.6,131 C0.6,99.4 26.2,73.8 57.8,73.8 L221.3,73.8 C252.9,73.8 278.5,99.4 278.5,131 L278.5,411.3 C278.5,442.8 252.9,468.4 221.3,468.4 Z",
    id: "Path",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.000000, 73.000000)",
    id: "Path",
    stroke: "#FEAC00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.3,
    y1: 0.8,
    x2: 1.3,
    y2: 395.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8,
    y1: 0.8,
    x2: 167.8,
    y2: 395.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.8,10.4 L89.3,10.4 C86.5,10.4 84.2,8.1 84.2,5.3 L84.2,5.3 C84.2,2.5 86.5,0.2 89.3,0.2 L189.7,0.2 C192.5,0.2 194.8,2.5 194.8,5.3 L194.8,5.3 C194.9,8.1 192.6,10.4 189.8,10.4 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 116.2,
    y: 111,
    width: 46.7,
    height: 16.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(765.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1,794.6 C13.1,794.6 11.2,804.7 11.9,811.4 C12.6,818.2 50.4,839.4 60.3,840.1 C70.7,840.8 87.2,837.6 85.3,819.7 C83.5,801.8 13.1,794.6 13.1,794.6 Z",
    id: "Path",
    fill: "#FEAC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,804.9 L66.1,805.5 C65.8,804.9 65.5,804.2 65.1,803.5 C53.7,782.6 12,780.4 12.8,797.4 C13.5,814.4 50,827.4 50,827.4 C50,827.4 50.1,827.4 50.2,827.4 C57.2,831.1 73,832 80.7,825.8 C80.7,825.7 87.8,823.5 83.1,804.9 Z",
    id: "Path",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1,794.6 C216.1,794.6 218,804.7 217.3,811.4 C216.6,818.2 178.8,839.4 168.9,840.1 C158.5,840.8 142,837.6 143.9,819.7 C145.6,801.8 216.1,794.6 216.1,794.6 Z",
    id: "Path",
    fill: "#FEAC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,804.9 L163,805.5 C163.3,804.9 163.6,804.2 164,803.5 C175.4,782.6 217.1,780.4 216.3,797.4 C215.6,814.4 179.1,827.4 179.1,827.4 C179.1,827.4 179,827.4 178.9,827.4 C171.9,831.1 156.1,832 148.4,825.8 C148.4,825.7 141.4,823.5 146,804.9 Z",
    id: "Path",
    fill: "#FFC933",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1,373.4 L41,805.9 C41,805.9 44.9,814.3 64.7,814.1 C82.3,814 88.9,806.6 88.9,806.6 L116.7,453.7 L145,807.9 C145,807.9 147.4,814.3 163.9,814.1 C186,813.8 190.3,805.9 190.3,805.9 L177.8,380.3 L52.1,373.4 Z",
    fill: "#283444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,127.2 C88.9,127.2 20.4,211.1 3.8,238.1 C-12.9,265.1 42.7,353.9 42.7,353.9 L50.1,305.5 L35.1,251.8 L74.3,198.9 L88.9,127.2 Z",
    fill: "#FE8163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,127.2 C163.8,127.2 216.1,210.4 232.8,237.4 C249.5,264.4 186,354.2 186,354.2 L181.7,304.3 L201.5,251.2 L172.8,203.4 L163.8,127.2 Z",
    fill: "#FE8163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,127.2 C88.9,127.2 99.1,121.6 109.7,120 C120.3,118.4 135.7,120 135.7,120 C135.7,120 149.5,121.3 163.8,127.2 C176.6,132.5 189.9,380 189.9,380 C189.9,380 171.7,395.4 112.8,395.7 C71.1,395.9 63.5,392.9 38.6,377.3 C38.6,377.3 69.9,167.1 88.9,127.2 Z",
    fill: "#FE8163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5,24.2 C88.5,24.2 85.7,88.2 108.9,91.9 C132.1,95.6 144.7,82.9 149.5,73.2 C154.3,63.5 160.3,44.8 157.7,24.2 C155.1,3.6 98.3,-10.3 88.5,24.2 Z",
    fill: "#FFDFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,89 L112.1,119.7 C112.1,119.7 121.1,127.4 138.2,120.3 L134.3,82.3 L116.8,89 Z",
    fill: "#FFDFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5,24.2 L97.1,26.4 L97.1,52.7 L100.1,53.7 C100.1,53.7 98.4,38.4 103.1,36.3 C112.6,32 114.9,40.9 114.1,47 C113.2,53.4 114.3,58 105.1,62.3 C105.1,62.3 107.4,81.7 117.6,86.2 C127.3,90.5 144.3,90.4 150.6,74.5 C155.1,63 172.5,26.5 148.6,10.4 C124.7,-5.7 109,1.9 104.3,3.2 C97.8,5 91.8,5.3 88.4,6.4 C85,7.6 79.9,13.1 88.5,24.2 Z",
    fill: "#283444"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,187.6 C183.6,262.4 189.9,379.9 189.9,379.9 C189.9,379.9 171.7,395.3 112.8,395.6 C71.1,395.8 63.5,392.8 38.6,377.2 C38.6,377.2 55.8,261.4 72.5,185.4",
    id: "Path",
    stroke: "#FF562F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,329.7 L86.2,329.7 C79.6,329.7 74.2,324.3 74.2,317.7 L74.2,209.6 C74.2,189 91.1,172.1 111.7,172.1 L138.5,172.1 C159.1,172.1 176,189 176,209.6 L176,317.7 C176,324.3 170.6,329.7 164,329.7 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,174.6 C137.4,174.6 136.4,173.9 136.1,172.8 C134.2,166.6 130.6,164.6 123.2,165.6 C116.6,166.5 115.5,172.3 115.4,172.5 C115.2,173.9 113.9,174.8 112.5,174.5 C111.1,174.3 110.2,173 110.5,171.6 C111.1,168.3 114.3,161.6 122.6,160.6 C132.3,159.3 138.3,162.8 140.9,171.3 C141.3,172.6 140.6,174 139.3,174.4 C139,174.5 138.7,174.6 138.5,174.6 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,185.8 C97.5,185.8 97.5,185.8 97.4,185.8 C94.6,185.7 92.5,183.3 92.6,180.6 C92.6,180.4 93.3,163.4 92.6,145.9 C91.9,130 90.8,126.2 90.8,126.2 L100,122.3 C100.6,123.6 101.9,128.5 102.6,145.5 C103.4,163.5 102.6,180.4 102.6,181.1 C102.4,183.7 100.2,185.8 97.6,185.8 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,185.8 C152.7,185.8 152.7,185.8 152.8,185.8 C155.6,185.7 157.7,183.3 157.6,180.6 C157.6,180.4 156.9,163.4 157.6,145.9 C158.3,130 159.9,125.3 159.9,125.3 L150.3,122.3 C149.7,123.6 148.4,128.5 147.7,145.5 C146.9,163.5 147.7,180.4 147.7,181.1 C147.7,183.7 149.9,185.8 152.6,185.8 Z",
    id: "Path",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.000000, 270.000000)",
    fill: "#283444",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.5,8 C126.8,19.9 120.5,22.5 120.2,22.6 L120.3,22.6 L122.5,32.4 C122.9,32.3 130.4,29.4 134.7,17.2 C134.2,10.4 133.2,-2.27373675e-13 133.2,-2.27373675e-13 C133.2,-2.27373675e-13 132,6.9 131.5,8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1,32.4 C27.3,32.4 27.5,32.4 27.7,32.4 C30.2,32.4 32.4,30.5 32.7,28 C33,25.3 31.1,22.8 28.3,22.5 C27.6,22.4 10.2,20.6 4.7,6.7 C4.5,6.2 3.2,2.6 3.2,2.6 C3.2,2.6 1.3,13 0.4,18 C10,29.2 26.3,32.3 27.1,32.4 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.1,229.5 L82.1,209.1 C82.1,199.5 89.9,191.7 99.5,191.7 L148.9,191.7 C158.5,191.7 166.3,199.5 166.3,209.1 L166.3,229.5",
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3,310.8 L95.9,310.8 C91.2,310.8 87.4,307 87.4,302.3 L87.4,270.2 C87.4,265.5 91.2,261.7 95.9,261.7 L154.3,261.7 C159,261.7 162.8,265.5 162.8,270.2 L162.8,302.3 C162.8,307 159,310.8 154.3,310.8 Z",
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.4,
    y1: 275.5,
    x2: 162.8,
    y2: 275.5,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1072.000000, 1120.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.5,177.7 L0.1,177.7 L0.1,173.6 C0.1,161.2 10.2,151.1 22.6,151.1 L550,151.1 C562.4,151.1 572.5,161.2 572.5,173.6 L572.5,177.7 Z",
    id: "Path",
    fill: "#37B37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.6,130 L32.1,130 C14.5,130 0.2,115.7 0.2,98.1 L0.2,32.2 C0.2,14.6 14.5,0.3 32.1,0.3 L540.6,0.3 C558.2,0.3 572.5,14.6 572.5,32.2 L572.5,98.1 C572.5,115.7 558.2,130 540.6,130 Z",
    id: "Path",
    fill: "#37B37F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 46.000000)",
    fill: "#283444",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2,298.4 L0.7,298.4 L0.7,13.6 C0.7,6.6 6.4,0.8 13.5,0.8 L13.5,0.8 C20.5,0.8 26.3,6.5 26.3,13.6 L26.3,298.4 L26.2,298.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,298.4 L450.5,298.4 L450.5,13.6 C450.5,6.6 456.2,0.8 463.3,0.8 L463.3,0.8 C470.3,0.8 476.1,6.5 476.1,13.6 L476.1,298.4 L476,298.4 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#283444",
    x: 83.9,
    y: 177.7,
    width: 22.7,
    height: 112.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#283444",
    x: 466.5,
    y: 177.7,
    width: 22.7,
    height: 112.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.2,212.5 L909.2,212.5 C909.2,212.5 883.4,133.9 824.4,138.1 C765.4,142.2 705.7,174 682.3,153.6 C658.9,133.2 604.3,78.8 555.6,96.9 C506.9,115 531,152.9 442.5,138.1 C387.5,128.9 373.2,212.5 373.2,212.5 Z",
    id: "Path",
    fill: "#F1F2F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.4,315.7 C1088.4,315.7 1115.9,260.1 1169.1,257.9 C1222.4,255.6 1232.6,293 1268.9,286.8 C1305.2,280.6 1361.9,210.3 1450.3,212.5 C1538.7,214.8 1570.5,315.7 1570.5,315.7 L1088.4,315.7 Z",
    id: "Path",
    fill: "#F1F2F7",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelTrainStation);
export default __webpack_public_path__ + "static/media/travel-train-station.43098970d22cd241f781f43b691cb9ab.svg";
export { ForwardRef as ReactComponent };